export const environment = {
    production: false,
    authCookieName: 'zitadel_access_token',
    API_ROOT: 'https://api.estimator.staging.flyevo.com/api/',
    sentryEnvName: 'staging-frontend',
    sentryDSN: 'https://9d39586c5f6e6f9ecece81263848790e@sentryv2.zitemedia.com/17',
    zitadelUrl: 'https://sso.flyevo.com',
    zitadelUrlEndSession: 'https://estimator.staging.flyevo.com/login',
    zitadelClientId: '340130203432913411',
    zitadelRedirectUri: 'https://estimator.staging.flyevo.com/login',
    plausibleDomain: 'estimator.staging.flyevo.com',
    plausibleDomainBriefings: 'briefings.staging.flyevo.com',
    plausibleEndpoint: 'https://plausible.zitemedia.com/api/event',
    estimatorOrigin: 'https://estimator.staging.flyevo.com',
    briefingsOrigin: 'https://briefings.staging.flyevo.com',
};
